import { render, staticRenderFns } from "./ClientLiableForm.vue?vue&type=template&id=0279fd90&"
import script from "./ClientLiableForm.vue?vue&type=script&lang=js&"
export * from "./ClientLiableForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientLiableForm.vue?vue&type=style&index=0&id=0279fd90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports